import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import LazyImage from '../LazyImage';
import LazyBackgroundImage from '../LazyBackgroundImage';

function getImageLayout({ imageSize, layout }) {
  switch (imageSize) {
    case 'cover':
      return css`
        background-position: ${layout === 'left' ? 'left top' : 'right top'};
        background-size: cover;
      `;
    case 'contain':
      return css`
        background-position: center center;
        background-size: contain;
      `;
    case 'custom':
      return css``;
    default:
      return css`
        background-position: center center;
        background-size: ${imageSize};
      `;
  }
}

const MobileLazyImage = styled(LazyImage)`
  display: ${({ src }) => (src ? 'block' : 'none')};
  flex: none; // IE 11 handles nested flex, 100% width children differently.
  width: 100%;
`;

const DesktopLazyBackgroundImage = styled(LazyBackgroundImage)`
  display: block;
  background-repeat: no-repeat;
  height: auto;
  min-height: 100%;
  width: 100%;
  ${({ aspectRatio }) =>
    aspectRatio ? `padding-bottom: ${aspectRatio};` : ``};
  ${getImageLayout};
`;

const ImageContainer = styled.div`
  width: 100%;
  ${({ fullHeight }) => (fullHeight ? `height: 100%;` : ``)};
`;

export default class SlatImage extends Component {
  static propTypes = {
    image: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    imageSize: PropTypes.string.isRequired,
    layout: PropTypes.oneOf(['left', 'right', 'center', 'custom']),
    aspectRatio: PropTypes.string,
    isMobile: PropTypes.bool,
    isPreloadedCallback: PropTypes.func,
  };

  static defaultProps = {
    imageSize: 'cover',
    layout: 'center',
    isMobile: true,
  };

  componentDidMount() {
    const { isPreloadedCallback } = this.props;

    // Using background-image so we don't know when its loaded so default ready.  <img /> can do this correctly.
    if (isPreloadedCallback) isPreloadedCallback();
  }

  render() {
    const {
      className,
      image,
      mobileImage,
      alt = 'image',
      imageSize,
      aspectRatio,
      layout,
      isMobile,
    } = this.props;

    let displayedImage = isMobile ? (
      <MobileLazyImage
        className={'image-container'}
        src={mobileImage}
        imageSize={imageSize}
        layout={layout}
        aspectRatio={aspectRatio}
        alt={alt}
      />
    ) : (
      <DesktopLazyBackgroundImage
        className={'image-container'}
        backgroundImage={image}
        imageSize={imageSize}
        layout={layout}
        aspectRatio={aspectRatio}
      />
    );

    return (
      <ImageContainer className={className} fullHeight={!aspectRatio}>
        {displayedImage}
      </ImageContainer>
    );
  }
}
